import React, { SVGProps } from 'react'

export const IconCardOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5715 8.38612V4.78475C20.5715 3.58628 20.5715 2.98704 20.3045 2.61878C20.0712 2.29703 19.71 2.07846 19.3033 2.01302C18.8378 1.93812 18.2624 2.18924 17.1117 2.69147L8.16616 7.14979C7.13986 7.59771 6.62671 7.82166 6.25087 8.169C5.9186 8.47606 5.66498 8.85089 5.50938 9.26484C5.33337 9.73308 5.33337 10.2675 5.33337 11.3364V18.4726M5.33337 12.9971L5.33337 25.389C5.33337 27.003 5.33337 27.81 5.66554 28.4265C5.95773 28.9687 6.42396 29.4096 6.9974 29.6859C7.64932 30 8.50274 30 10.2096 30H21.7905C23.4973 30 24.3508 30 25.0027 29.6859C25.5761 29.4096 26.0423 28.9687 26.3345 28.4265C26.6667 27.81 26.6667 27.003 26.6667 25.389V12.9971C26.6667 11.3831 26.6667 10.5761 26.3345 9.95964C26.0423 9.41738 25.5761 8.97652 25.0027 8.70022C24.3508 8.38612 23.4973 8.38612 21.7905 8.38612L10.2096 8.38612C8.50274 8.38612 7.64932 8.38612 6.9974 8.70022C6.42396 8.97652 5.95773 9.41738 5.66554 9.95964C5.33337 10.5761 5.33337 11.3831 5.33337 12.9971Z"
      stroke="#00204D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
